import {
  GetIBSAvailabilityResponse,
  GetIBSHistoryListResponse,
  GetIBSQuestionListResponse,
  GetIBSResultResponse,
  GetIBSTemporaryResponse,
  GetIbsHasIBSHistoryResponse,
  PostIBSFormRequestBody,
  PostIBSFormResponse,
} from "models/Ibs";
import request from "./core";

export const getIbsHasIBSHistory = () => {
  return request.get<GetIbsHasIBSHistoryResponse>(`/ibs/hasIBSHistory`);
};

export const getIBSHistoryList = ({ page }: { page: number }) => {
  return request.get<GetIBSHistoryListResponse>(`/ibs`, {
    params: {
      page,
      size: 10,
    },
  });
};

export const getIBSResult = ({ ibsSurveyId }: { ibsSurveyId: number }) => {
  return request.get<GetIBSResultResponse>(`/ibs/${ibsSurveyId}`);
};

export const getIBSTemporary = () => {
  return request.get<GetIBSTemporaryResponse>(`/ibs/temporary`);
};

export const getIBSQuestionList = () => {
  return request.get<GetIBSQuestionListResponse>(`/ibs/representative`);
};

export const getIBSAvailability = () => {
  return request.get<GetIBSAvailabilityResponse>(`/ibs/enable`);
};

export const postIBSForm = ({ ibsId, questions }: PostIBSFormRequestBody) => {
  return request.post<PostIBSFormResponse>(`/ibs`, { ibsId, questions });
};
